// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3af18b98","455":"8c5d1790","977":"591b233a"}[chunkId] + ".chunk.js";
};